import type { PropsWithChildren } from 'react'
import { space, tok, withStyleModifiers } from '@sunwebgroup/ui-components'
import { Popover, resetFocusOutline, Token, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, styled } from 'styled-components'
import { BaseInput } from '../BaseInput'
import { DropdownMultiselectContext } from './context'

const Chips = styled.div<{ $disabled: boolean | undefined }>`
  align-items: center;
  display: flex;
  min-width: 0;
  position: relative;

  > * {
    margin-right: ${space('primitives_space_4')};

    &:last-child {
      margin-right: 0;
    }
  }

  ${Token} {
    ${resetFocusOutline()}
  }

  ${({ $disabled }) =>
    $disabled
    && css`
      pointer-events: none;
    `}
`
const Placeholder = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
  margin-right: ${space('primitives_space_24')};
  color: ${tok('semantics_input_fields_placeholder_color')};
`

function modDisabled() {
  return css`
    ${BaseInput.modDisabled()}
  `
}

export const Selection = withStyleModifiers(styled(SelectionPrimitive)``, { modDisabled })

function SelectionPrimitive({ children, className, ...rest }: PropsWithChildren<{ className?: string }>) {
  const { selectedValues, disabled, placeholder } = React.use(DropdownMultiselectContext)
  const hasValue = selectedValues.length > 0

  const content = (
    <BaseInput.Root className={className} {...rest}>
      <BaseInput.Box tabIndex={disabled ? undefined : 0} $hasValue={hasValue}>
        {hasValue
          ? (
              <>
                <BaseInput.Content>
                  <Chips $disabled={disabled}>{children}</Chips>
                </BaseInput.Content>
              </>
            )
          : (
              <>
                <Placeholder variant="body-m-regular-tight">{placeholder}</Placeholder>
              </>
            )}
      </BaseInput.Box>
      <BaseInput.ChevronDown />
    </BaseInput.Root>
  )

  return <Popover.Trigger>{content}</Popover.Trigger>
}
